import { render, staticRenderFns } from "./searchDefault.vue?vue&type=template&id=39ea462d"
import script from "./searchDefault.vue?vue&type=script&lang=js"
export * from "./searchDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AutoSuggest: require('/home/ubuntu/containers/hermes_eshop/components/core/autoSuggest.vue').default})
